/** @format */

import React from "react";
import { FaCar } from "react-icons/fa6";
import { RiShieldCheckFill } from "react-icons/ri";

const coverageItems = [
  {
    variant: "approved",
    title: "Uber and Instadoc approved",
    description: "All our insurers are Uber and Instadoc approved.",
    icon: RiShieldCheckFill,
  },
  {
    variant: "cover",
    title: "Private hire and ride-hailing cover",
    description: (
      <>
        <span className="tw-font-bold">Great news!</span> All
        our insurers will cover you for Private Hire and all ride-hailing
        platforms. Cover provided in line with your policy terms.
      </>
    ),
    icon: FaCar,
  },
];

const TqPanelCoverageCard = () => {
  return (
    <div className="tw-mb-5 tw-overflow-hidden tw-rounded-[14px] tw-border tw-border-solid tw-border-dis-border-strong tw-bg-dis-info-hover">
      {coverageItems.map((item, index) => {
        const Icon = item.icon;
        const isApproved = item.variant === "approved";

        return (
          <div
            key={item.title}
            className={`tw-flex tw-items-start tw-gap-3 tw-border-0 tw-p-4 ${
              index < coverageItems.length - 1
                ? "tw-border-b tw-border-solid tw-border-dis-border-strong"
                : ""
            }`}
          >
            <div
              className={`tw-flex tw-h-10 tw-w-10 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-xl ${
                isApproved
                  ? "tw-bg-dis-sky-tint tw-text-dis-deep-blue"
                  : "tw-bg-dis-success-bg tw-text-dis-success"
              }`}
            >
              <Icon className="tw-h-5 tw-w-5" aria-hidden="true" />
            </div>
            <div className="tw-min-w-0 tw-flex-1">
              <p
                className={`tw-m-0 tw-mb-1 tw-text-base tw-font-bold tw-leading-[1.35] ${
                  isApproved ? "tw-text-dis-deep-blue" : "tw-text-dis-success"
                }`}
              >
                {item.title}
              </p>
              <p className="tw-m-0 tw-text-dis-small tw-leading-[1.5] tw-text-dis-text-2">
                {item.description}
              </p>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default TqPanelCoverageCard;
